module.exports = __webpack_public_path__ + "static/media/25-point-player.b55cc3ad.png";